import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-powered-by.svg'


const _hoisted_1 = { class: "estate-map-header" }
const _hoisted_2 = { class: "estate-map-wrapper-logo" }
const _hoisted_3 = {
  key: 0,
  class: "wrapper-burger"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "buttons-content"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", [{ 'estate-header': $props.estate }]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-container", { container: $props.estate }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (false && !$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(["burger", { 'burger-active': $setup.showMobileMenu }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showMobileMenu = !$setup.showMobileMenu))
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", null, null, -1),
                  _createElementVNode("div", null, null, -1),
                  _createElementVNode("div", null, null, -1)
                ]))], 2)
              ]))
            : _createCommentVNode("", true),
          ($props.estate?._id)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'EstateMap', params: { estateId: $props.estate._id } }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: $props.estate.logoUrl
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        ($setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode($setup["DropDown"], { class: "dropdown-container-display-none" }, {
                control: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("label", {
                    class: "dropdown-button input-dropdown input-modified",
                    type: "button"
                  }, "Guides", -1)
                ]))]),
                dropdown: _withCtx(() => [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timePeriod, (period) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: period,
                        onClick: ($event: any) => (_ctx.selectTimePeriod(period)),
                        class: _normalizeClass({ 'dropdown__item-active': period === _ctx.selectedTimePeriod })
                      }, _toDisplayString(period), 11, _hoisted_6))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              false
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button primary result",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('calculate')))
                  }, "Calculate my Borrowing Capacity"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-menu", { show: $setup.showMobileMenu }])
    }, [
      _createElementVNode("ul", null, [
        (!$setup.isDesktop)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.builderCalculatorNavigation, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "menu-item",
                key: index
              }, [
                _createElementVNode("div", {
                  class: "menu-link",
                  onClick: ($event: any) => ($setup.handleEmit(item.emit))
                }, [
                  _createElementVNode("img", {
                    class: "menu-icon",
                    src: require(`@/assets/icons/${item.icon}`)
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.label), 1)
                ], 8, _hoisted_7)
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "wrapper-powered-by" }, [
        _createElementVNode("img", { src: _imports_0 })
      ], -1))
    ], 2)
  ], 2))
}